module.exports = __webpack_public_path__ + "static/media/Paus soffa 2-sits med recliners pausakomb375hg miljö 2023 1.1f83afd5.jpg";